import { currencyFormatter } from '@homeaway/hacommons-i18n';
import { defaultCurrency, fallbackConversionRates, currencyBySite } from './constants';

/**
 * Return the currency object for the specified site name (e.g., "homeaway_es").
 *
 * @param {string} siteName
 * @return {*}
 */
export const getCurrencyBySiteName = siteName => currencyBySite[siteName] || defaultCurrency;

export const getFallbackConversionRateFromUSD = toCurrency => fallbackConversionRates[toCurrency]
|| 1;

export const convertCurrencyFromUSDWithFallback = (value, toCurrency) => {
    if (toCurrency !== 'USD') {
        return Math.floor(value * getFallbackConversionRateFromUSD(toCurrency));
    }
    return value;
};

export const formatWithLocalCurrency = (value, locale, currencyCode = 'USD', maxDigits = 0) => currencyFormatter.formatNumber(
    {
        value,
        currencyCode,
        locale,
        maximumFractionDigits: maxDigits,
        minimumFractionDigits: 0,
        useGrouping: true
    }
);

export default {
    getCurrencyBySiteName,
    convertCurrencyFromUSDWithFallback,
    getFallbackConversionRateFromUSD,
    formatWithLocalCurrency
};
